import NiceSelect from 'nice-select2/dist/js/nice-select2';

export default () => ({
  sended: false,
  init() {
    let form = this.$el.querySelector('.wpcf7-form');
    let btn = form.querySelector('.wpcf7-submit');
    let block = this.$el.querySelector('.wpcf7');
    btn.setAttribute('disabled', true);

    function checkForm() {
      if (form.querySelectorAll('[aria-invalid="true"]').length) {
        btn.setAttribute('disabled', true);
      } else {
        btn.removeAttribute('disabled');
      }
    }
    
    form.addEventListener('change', () => setTimeout(checkForm, 100));
    block.addEventListener('wpcf7mailsent', () => this.sended = true);
    block.addEventListener('wpcf7submit', () => setTimeout(checkForm, 100));

    this.$el.querySelectorAll('.wpcf7-select').forEach(el => {
      let placeholder = el.children[0].text;
      el.children[0].setAttribute('disabled', true);
      let select = new NiceSelect(el, {placeholder: placeholder});
    });
  }
});